import { Env } from "@ancademy/vse-client";
import { ABU } from "@client";
import { Style } from "@client/style";
import { css, cx } from "@emotion/css";
import { Button } from "antd";
import React, { useRef } from "react";

export type TItemData = {
  name: string;
  seen: boolean;
  deposited?: boolean;
};

const ItemPositionList = [
  "-0.2m 0.1m -6.8m",
  "1m 0.1m -3m",
  "-2m 0.1m -3.5m",
  "-1.5m 0.1m -6.3m",
  "2.6m 0.1m -6m",
  "2.2m 0.1m -2.5m",
];

export function AMap({ items, onClick }: { items: TItemData[]; onClick: (i: number) => void }) {
  const ref = useRef(null);
  return (
    <>
      <model-viewer
        ref={ref}
        style={{ position: "fixed", width: "100vw", height: "100vh" }}
        src={`${ABU}model/city4.glb`}
        camera-controls={false}
        poster={`${ABU}model/poster4.png`}
        exposure="0.5"
        camera-orbit="90deg 70deg auto"
        camera-target="1m 0m -4.62m"
        min-camera-orbit="auto 60deg auto"
        max-camera-orbit="auto 85deg auto"
        interaction-prompt="none"
        min-field-of-view="7deg"
        max-field-of-view="13deg"
      >
        {items.map(({ name, deposited, seen }, i) => (
          <div
            key={i}
            className={css`
              border: none;
              width: 50px;
              height: 50px;
              background: ${`url(${ABU}img/poi-marker.png) ${11 * i}% ${deposited ? 60 : seen ? 100 : 20}% / 500px`};
              cursor: pointer;
            `}
            slot={`hotspot-${i}`}
            data-position={ItemPositionList[i]}
            onClick={() => onClick(i)}
          >
            <div
              className={css`
                background: #fff;
                border-radius: 4px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
                overflow-wrap: break-word;
                padding: 0.5em 1em;
                position: relative;
                bottom: 4rem;
                left: -50%;
                width: max-content;
                font-size: 1.2rem;
                font-weight: bold;
              `}
            >
              {name}
              <span
                className={css`
                  font-weight: normal;
                  font-size: 1rem;
                `}
              >
                {deposited ? "(已预订)" : seen ? "(已搜寻)" : ""}
              </span>
            </div>
          </div>
        ))}
      </model-viewer>
      {Env.isProd || (
        <Button
          className={cx(
            Style.btnPrimaryXS,
            css`
              position: fixed;
              right: 0;
              bottom: 5vh;
            `
          )}
          onClick={async () => {
            const blob = await ref.current.toBlob();
            const _a = document.createElement("a");
            _a.href = URL.createObjectURL(blob);
            _a.download = "poster.png";
            _a.click();
          }}
        >
          Download poster
        </Button>
      )}
    </>
  );
}
